import React from 'react';

export const BrushIcon = () => (
	<svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M17.01 0L18.43 1.42L12.71 7.13C13.78 8.67 13.93 10.52 13.03 11.72L6.71 5.4C7.91 4.5 9.76 4.65 11.3 5.72L17.01 0ZM3.58 14.85C1.57 12.84 0.34 10.44 0 8.2L4.88 6.11L12.32 13.55L10.23 18.43C7.99 18.09 5.59 16.86 3.58 14.85Z"
		/>
	</svg>
);
